import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Wrapper,
  Row,
  Button,
  Copy,
  Bold,
  Card,
  Icon,
  CardBody,
  Title
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import {
  /*mobile*/
  appRedirect
} from "app/NativeActions";
import { loadEngine } from "app/NativeActions";
import AllEngineFeatures from "./AllEngineFeatures";
import Plan from "../Engines/EnginePlans/Plan";

class SelectedEngines extends Component {
  constructor(props) {
    super(props);

    this.state = {
      all_features_plan: null
    };
  }

  render() {
    const { selected_engines, colors } = this.props;

    let plan_slug = "";
    if (selected_engines.length > 0) {
      plan_slug = selected_engines[0].engine;
      switch (selected_engines[0].tier) {
        case 1:
          plan_slug += "_basic";
          break;
        case 2:
        default:
          plan_slug += "_professional";
          break;
        case 3:
          plan_slug += "_enterprise";
          break;
      }
    }
    return (
      <Wrapper>
        <Wrapper style={{ padding: 20, paddingTop: 0 }}>
          <Row>
            {!this.props.isMobile ? (
              <Card
                style={{
                  minWidth: 300,
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "auto"
                }}
              >
                <CardBody style={{ padding: 15 }}>
                  <Copy
                    style={{
                      color: colors.light_text_color,
                      padding: 10,
                      paddingBottom: 0
                    }}
                  >
                    Every engine comes with the following:
                  </Copy>
                  <AllEngineFeatures colors={colors} />
                  <Button
                    onPress={() => {}}
                    style={{ padding: 10, paddingBottom: 0 }}
                  >
                    <Copy style={{ color: colors.light_text_color }}>
                      See all features
                    </Copy>
                  </Button>
                </CardBody>
              </Card>
            ) : null}
            {!this.props.isMobile ? (
              <Wrapper style={{ padding: 20 }}>
                <Icon icon={"add"} size={18} />
              </Wrapper>
            ) : null}
            {selected_engines.length > 0 ? (
              <Plan
                plan_slug={plan_slug}
                engine_slug={selected_engines[0].engine}
                colors={colors}
                exclude_select_button={true}
                selected_frequency={this.props.selected_frequency}
                full_title={true}
              />
            ) : !this.props.isMobile ? (
              <Wrapper
                style={{
                  borderStyle: "dashed",
                  borderColor: colors.border_color,
                  borderWidth: 2,
                  borderRadius: 5,
                  margin: 10,
                  alignSelf: "stretch",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <CardBody>
                  <Copy>
                    <Bold>Choose an option to continue</Bold>
                  </Copy>
                </CardBody>
              </Wrapper>
            ) : null}
          </Row>
        </Wrapper>
        {selected_engines.length > 0 ? (
          <Row
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingBottom: 40
            }}
          >
            <Wrapper style={{ padding: 10 }}>
              <Button onPress={() => this.props.clearEngines()}>
                <Copy>Select a different option.</Copy>
              </Button>
            </Wrapper>
            {selected_engines.length > 0 ? (
              <Row style={{ alignItems: "center", justifyContent: "center" }}>
                <PillButton
                  primary={true}
                  onPress={() => {
                    //set payment variables
                    this.props.setPaymentPage({
                      engine_slug: selected_engines[0].engine,
                      tier: selected_engines[0].tier,
                      frequency: selected_engines[0].frequency
                    });
                    this.props.appRedirect({
                      redirect: "onboardingConfirmPayment"
                    });
                  }}
                >
                  Confirm And Continue
                </PillButton>
              </Row>
            ) : null}
          </Row>
        ) : null}
      </Wrapper>
    );
  }
}

export default SelectedEngines;
